import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadPromotion),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadCardData),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadLocationData),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(loadSaga),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(watchSaga);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { selectUserDetectedLocation, selectUserSelectedLocation } from 'redux/modules/locale';
import { glsLocation } from 'redux/saga/entities/bound';
import { GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS } from 'constants/promotions';
import { isEmpty } from 'helpers/verify';
import { deepExtract } from 'helpers/deep';
import { doLoadPromotionData } from 'components/CmsPage/modules/PlanSelection/plan-selection.saga';
import { setMsaId } from 'redux/modules/features/homepage';
import { getMsa } from 'containers/LocationModal/location.saga';
export var PRODUCT_TYPES = {
  custom: 'custom',
  promotion: 'promotion'
};
export var PRODUCT_GROUP_DISCLAIMER_TYPES = {
  none: 'none',
  autoRenewal: 'auto-renewal'
};
export var LOAD_CARD_DATA = 'ProductGroup/LOAD_CARD_DATA';
export var loadCardData = function loadCardData() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      productType = _ref.productType,
      productCode = _ref.productCode;

  return {
    type: LOAD_CARD_DATA,
    productType: productType,
    productCode: productCode
  };
};
export function doLoadPromotion(client, _ref2) {
  var productCode, promoAlias, msa;
  return regeneratorRuntime.wrap(function doLoadPromotion$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          productCode = _ref2.productCode;
          promoAlias = productCode || GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS;
          _context.next = 4;
          return call(getMsa, client, {}, {
            redirectBackOnMissing: false
          });

        case 4:
          msa = _context.sent;

          if (isEmpty(msa)) {
            _context.next = 8;
            break;
          }

          _context.next = 8;
          return call(doLoadPromotionData, client, msa, promoAlias);

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doLoadCardData(client, _ref3) {
  var productType, productCode;
  return regeneratorRuntime.wrap(function doLoadCardData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          productType = _ref3.productType, productCode = _ref3.productCode;
          _context2.t0 = productType;
          _context2.next = _context2.t0 === PRODUCT_TYPES.promotion ? 4 : _context2.t0 === PRODUCT_TYPES.custom ? 7 : 7;
          break;

        case 4:
          _context2.next = 6;
          return call(doLoadPromotion, client, {
            productCode: productCode
          });

        case 6:
          return _context2.abrupt("break", 8);

        case 7:
          return _context2.abrupt("break", 8);

        case 8:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function doLoadLocationData(client) {
  var locations, _ref4, _ref5, userDetectedLocation, userSelectedLocation;

  return regeneratorRuntime.wrap(function doLoadLocationData$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return all([select(selectUserDetectedLocation), select(selectUserSelectedLocation)]);

        case 2:
          locations = _context3.sent;
          _context3.prev = 3;
          _context3.next = 6;
          return all(locations.filter(Boolean).map(function (_ref6) {
            var lat = _ref6.lat,
                lon = _ref6.lon;
            return call(fetchEntityIfNeeded, glsLocation, [client, lat, lon]);
          }));

        case 6:
          _ref4 = _context3.sent;
          _ref5 = _slicedToArray(_ref4, 2);
          userDetectedLocation = _ref5[0];
          userSelectedLocation = _ref5[1];
          _context3.next = 12;
          return put(setMsaId(deepExtract('msa.id', userSelectedLocation || userDetectedLocation)));

        case 12:
          _context3.next = 18;
          break;

        case 14:
          _context3.prev = 14;
          _context3.t0 = _context3["catch"](3);
          _context3.next = 18;
          return call(logger.error, 'ProductGroup: Could not fetch location using GLS', locations, _context3.t0);

        case 18:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[3, 14]]);
}
export function loadSaga(client, props) {
  var productType, productCode;
  return regeneratorRuntime.wrap(function loadSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          productType = props.productType, productCode = props.productCode;
          _context4.next = 3;
          return call(doLoadLocationData, client);

        case 3:
          _context4.next = 5;
          return call(doLoadCardData, client, {
            productType: productType,
            productCode: productCode
          });

        case 5:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
export function watchSaga(client) {
  return regeneratorRuntime.wrap(function watchSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return fork(takeEvery, loadCardData().type, loadSaga, client);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}